import { css } from '@emotion/css';
import { type JSX, useState } from 'react';
import { useTranslation } from 'react-i18next';

const containerFullscreen = css`
  z-index: 20;
  position: absolute;
  top: 0;
  left: 0;
`;

const semiTransparent = css`
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
`;

const container = (fullscreen: boolean): string => css`
  display: flex;
  position: static;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  transition: position 1s linear;

  ${fullscreen && containerFullscreen}
  ${fullscreen && semiTransparent}
`;

const imageContainer = css`
  max-height: 90%;
  max-width: 90%;
  border-radius: 15px;
  aspect-ratio: 1;
  text-align: center;
  position: relative;
  display: inline-block;
  height: auto;
  width: auto;
`;

const image = css`
  height: 100%;
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 15px;
`;

interface CaptureInstructionProps {
  src: string;
}

export function CaptureInstruction({
  src,
}: CaptureInstructionProps): JSX.Element {
  const [expanded, setExpanded] = useState(false);
  const toggle = (): void => {
    setExpanded(!expanded);
  };
  const { t } = useTranslation();

  return (
    <div className={container(expanded)}>
      <div className={imageContainer}>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <img
          className={image}
          height="100%"
          width="auto"
          src={src}
          alt={t('imageAlt.instruction')}
          onClick={toggle}
        />
      </div>
    </div>
  );
}
